import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deps: {},
      detailsModalShow: false,
      selectedTechs: [],
      selectedRoles: [],
    };
  }

  // -----------------------------
  //  Helpers
  // -----------------------------

  getAllTechs() {
    const { resumeProjects } = this.props;
    if (!resumeProjects) return [];

    return [
      ...new Set(
        resumeProjects
          .flatMap((p) => p.technologies || [])
          .map((t) => t.name || t)
      ),
    ];
  }

  getAllRoles() {
    const { resumeProjects } = this.props;
    if (!resumeProjects) return [];

    return [
      ...new Set(resumeProjects.flatMap((p) => p.roles || [])),
    ];
  }

  toggleFilter = (type, value) => {
    this.setState((prevState) => {
      const list = prevState[type];
      return {
        [type]: list.includes(value)
          ? list.filter((v) => v !== value)
          : [...list, value],
      };
    });
  };

  filterProjects(projects) {
    const { selectedTechs, selectedRoles } = this.state;

    if (selectedTechs.length === 0 && selectedRoles.length === 0)
      return projects;

    return projects.filter((project) => {
      const techMatch =
        selectedTechs.length === 0 ||
        (project.technologies || []).some((t) =>
          selectedTechs.includes(t.name || t)
        );

      const roleMatch =
        selectedRoles.length === 0 ||
        (project.roles || []).some((r) => selectedRoles.includes(r));

      return techMatch && roleMatch;
    });
  }

  // -----------------------------
  //  Render UI
  // -----------------------------

  renderFilters() {
    const allTechs = this.getAllTechs();
    const allRoles = this.getAllRoles();
    
    return (

      <h3 className="filter-container" style={{ color: "black" }}>
        {allRoles.map((role) => (
              <label key={role} className={`chip ${this.state.selectedRoles.includes(role) ? "chip-selected" : ""}`}>
                <input
                  type="checkbox"
                  checked={this.state.selectedRoles.includes(role)}
                  onChange={() => this.toggleFilter("selectedRoles", role)}
                />
                {role}
              </label>
            ))}
      </h3>

    );
  }

  renderProjects() {
    const { resumeProjects } = this.props;
    if (!resumeProjects) return null;

    const filtered = this.filterProjects(resumeProjects);

    return (
      <div className="projects-grid">
        {filtered.map((project) => (
          <div
            className="project-card"
            key={project.title}
            onClick={() =>
              this.setState({ detailsModalShow: true, deps: project })
            }
          >
            <div className="project-card-image-wrapper">
              <img
                src={project.thumbnail}
                alt={project.title}
                className="project-card-image"
              />
            </div>

            <div className="project-card-body">
              <div className="project-card-header-row">
                <h5 className="project-card-title">{project.title}</h5>
                <div className="project-card-meta">
                  <span className="badge bg-secondary text-light">
                    {project.startDate}
                  </span>
                  <span className="badge bg-secondary text-light">
                    {project.type}
                  </span>
                </div>
              </div>

              <div className="project-card-techroles">
                {project.roles?.map((role, idx) => (
                  <span key={idx} className="badge bg-success text-light">
                    {role}
                  </span>
                ))}
                {project.technologies?.map((tech, idx) => (
                  <span key={idx} className="badge bg-info text-light">
                    {tech.name || tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // -----------------------------
  //  Main render
  // -----------------------------

  render() {
    const sectionName =
      this.props.resumeBasicInfo?.section_name.projects ?? "";

    return (
      <section id="portfolio">
        <h1 className="section-title" style={{ color: "black" }}>
          <span>{sectionName}</span>
        </h1>

        {this.renderFilters()}

        <h3 className="subsection-title" style={{ color: "black" }}>
          <span>Select a project below for links, images, and more</span>
        </h3>

        {this.renderProjects()}

        <ProjectDetailsModal
          show={this.state.detailsModalShow}
          onHide={() => this.setState({ detailsModalShow: false })}
          data={this.state.deps}
        />
      </section>
    );
  }
}

export default Projects;
